const T = {
  fr: {
    // Hero
    brand_sub: "Tes stats ont des choses à dire sur toi. Pas toujours flatteuses.",
    seo_intro: "Roast My Stats est un outil d'analyse LoL : entre ton pseudo, obtiens un score sur 100, un badge basé sur ton champion principal et des conseils concrets pour améliorer ton niveau. Notre analyse couvre le winrate, les performances par champion, la progression sur la saison et bien plus — disponible sur toutes les régions.",
    total_reports: (n) => `${n.toLocaleString("fr-FR")} joueurs roastés`,
    see_leaderboard: "Voir le classement",
    see_offers: "Voir les offres",
    go_premium: "Débloquer le Pass 24h — 1,99€",
    pass_badge: (h) => `Pass — ${h} h`,
    logout: (name) => `${name}  ·  Se déconnecter`,
    lang_toggle: "EN",

    // Search
    search_placeholder: "Pseudo (ou plusieurs séparés par une virgule)",
    btn_report: "Rapport joueur",
    btn_squad: "Squad ranking",
    btn_demo: "Démo",
    btn_demo_squad: "Démo Squad",

    // Searches remaining
    limit_reached: "Limite quotidienne atteinte",
    searches_remaining: (n) => `${n} recherche${n > 1 ? "s" : ""} restante${n > 1 ? "s" : ""} aujourd'hui`,

    // Loading
    loading_premium: "Analyse approfondie de 50 parties...",
    loading_free: "Analyse de 30 parties...",
    loading_anon: "Analyse de 20 parties — crée un compte pour plus de précision",
    loading_demo: "Génération de la démo...",
    loading_squad: "Génération du squad démo...",

    // Errors
    error_not_found: "Joueur introuvable. Vérifie le pseudo (format : Pseudo#TAG) et la région.",
    error_try_demo: "Voir un exemple →",
    error_squad_premium: "Le Squad Ranking est une fonctionnalité Premium.",
    error_squad: "Erreur lors de la génération du squad.",
    error_demo: "Erreur lors de la démo.",
    error_demo_squad: "Erreur lors de la démo squad.",
    go_premium_btn: "Passer Premium →",

    // Leaderboard page
    leaderboard_page_title: "Classement Global",
    leaderboard_best: "Meilleur score par joueur",
    leaderboard_updated: "Mis à jour à chaque rapport généré",
    leaderboard_empty: "Aucun joueur classé pour l'instant.",
    leaderboard_analyze: "Analyser mon profil",
    back: "← Retour",

    // Leaderboard submit
    lb_submit_label: "Ajouter un pseudo au classement public :",
    lb_submit_placeholder: "Pseudo#TAG",
    lb_submit_btn: "Rejoindre",
    lb_submit_done: "✓ Ajouté",

    // Squad
    squad_title: "Squad Ranking",
    new_report: "← Nouveau rapport",

    cancel: "Annuler",

    // Pricing
    choose_offer: "Choisir une offre",
    choose_offer_sub: "Compare les offres et trouve celle qui te correspond",
    plan_no_account: "Sans compte",
    plan_free: "Compte gratuit",
    plan_premium: "Premium",
    plan_free_price: "Gratuit",
    plan_free_account_price: "0€",
    plan_premium_price: "1,99€ / 24h",
    quota_anon: "3 rapports / jour",
    quota_free: "5 rapports / jour",
    quota_premium: "Rapports illimités",
    feature_history: "Historique des rapports",
    feature_suggestions: "Suggestions de recherche",
    feature_share: "Partage de rapport",
    feature_themes: "Thèmes visuels",
    feature_squad: "Squad Ranking",
    feature_community: "Profil communauté",
    feature_ai_coach: "Coach IA personnalisé",
    feature_referrals_none: "Lien de parrainage",
    feature_referrals_link: "Lien de parrainage à partager",
    create_account: "Créer un compte",
    go_premium_cta: "Débloquer le Pass 24h",
    active_badge: "Actif",

    // Pass 24h — remplace la liste d'attente depuis le 2026-09-08.
    // Le texte ne pretend pas a une panne : le paiement n'est pas ouvert, et on
    // le dit. La contrepartie annoncee, elle, est bien reelle.
    going_premium: "Le Pass 24h arrive 🚀",
    pass_body_anon: "Le paiement n'est pas encore ouvert : on mesure l'intérêt avant de brancher la caisse. Laisse ton e-mail — on t'offre un Pass 24h complet le jour de l'ouverture. Et pour te remercier d'être arrivé avant tout le monde, ton Premium est débloqué tout de suite, pendant 24h.",
    pass_body_user: "Le paiement n'est pas encore ouvert : on mesure l'intérêt avant de brancher la caisse. Le jour de l'ouverture, ton premier Pass 24h est offert. Et pour te remercier d'être arrivé avant tout le monde, ton Premium est débloqué tout de suite, pendant 24h.",
    pass_cta_anon: "Débloquer mes 24h Premium",
    email_placeholder: "ton@email.com",
    pass_cta_user: "Profiter du Premium gratuit",
    pass_success_title: "C'est débloqué 🎉",
    pass_success_body: "Tes 24h de Premium sont actives. Va te faire roaster correctement.",
    pass_success_mail: "On vient de t'envoyer un e-mail pour choisir ton mot de passe et garder ton compte.",
    pass_already_title: "Tu es déjà Premium",
    pass_already_body: "Ton accès Premium est déjà actif — pas besoin de pass pour l'instant.",
    pass_existing_account: "Un compte existe déjà avec cette adresse. Connecte-toi, puis reclique pour débloquer tes 24h.",
    pass_error: "Impossible de débloquer le pass pour le moment. Réessaie dans un instant.",
    close: "Fermer",

    // Share
    share_title: "Partager Mon Rapport",
    feature_roast_levels: "Curseur de méchanceté + re-roast",
    prog_title: (jours) => `Ta progression sur ${jours} jours`,
    prog_score: "Score",
    prog_deaths: "Morts par partie",
    prog_kda: "KDA",
    prog_winrate: "Winrate",
    trophies_title: "Trophées",
    trophies_new: (noms) => `Nouveau trophée débloqué : ${noms}`,
    roast_gentil: "Gentil",
    roast_piquant: "Piquant",
    roast_sans_pitie: "Sans pitié",
    roast_again: "Re-roast",
    roast_loading: "Ça chauffe...",
    roast_error: "Le roast n'a pas voulu sortir, réessaie.",
    share_message_label: "Message prêt à coller :",
    share_message: (score, badge, url) => `Je viens d'analyser mes stats LoL — ${score}/100, "${badge}"\nTente de faire mieux :\n${url}`,
    discord_message: (player, score, badge, url) => `**Roast My Stats** — ${player}\nScore : **${score}/100** · *${badge}*\n${url}`,
    copy_message: "Copier le message",
    link_only: "Lien seul :",
    copy: "Copier",
    discord_copied: "Message Discord copié — colle-le dans ton serveur !",

    // Reset password
    new_password_title: "Nouveau mot de passe",
    pw_new_label: "Nouveau mot de passe",
    pw_confirm_label: "Confirmer le mot de passe",
    pw_reset_btn: "Réinitialiser le mot de passe",
    pw_updated_title: "Mot de passe mis à jour !",
    pw_updated_sub: "Tu peux maintenant te connecter.",
    login_btn: "Se connecter",

    // Settings
    settings_title: "Paramètres",
    tab_account: "Compte",
    tab_password: "Mot de passe",
    tab_premium: "Premium",
    tab_visual: "Visuel",

    // Premium tab
    pass_ongoing: (h) => `Pass 24h en cours — ${h} h restante${h > 1 ? "s" : ""}`,
    upgrade_premium: "Débloquer le Pass 24h — 1,99€",
    referral_title: "Ton lien de parrainage",
    referral_sub: "Tes filleuls reçoivent leur premier Pass 24h offert à l'inscription, comme toi.",
    referral_gift_banner: "Un Pass 24h offert t'attend — inscris-toi maintenant !",
    regenerate: "Régénérer",
    link_copied: "Lien copié !",
    new_link_generated: "Nouveau lien généré !",
    cancel_subscription: "Arrêter mon abonnement",
    cancel_sub_confirm_msg: "Es-tu sûr ? Tu perdras l'accès Premium immédiatement.",
    cancel_sub_confirm_btn: "Oui, arrêter l'abonnement",

    // Password tab
    pw_current: "Mot de passe actuel",
    pw_new_placeholder: "Nouveau mot de passe",
    pw_confirm_placeholder: "Confirmer le nouveau mot de passe",
    change_password: "Changer le mot de passe",
    criteria_8chars: "8 caractères minimum",
    criteria_uppercase: "Une majuscule",
    criteria_number: "Un chiffre",
    criteria_special: "Un caractère spécial",

    // Account tab
    label_name: "Nom",
    label_email: "Email",
    label_subscription: "Abonnement",
    label_language: "Langue",
    sub_premium: "Premium",
    sub_free: "Gratuit",
    delete_account: "Supprimer mon compte",
    delete_confirm_msg: "Cette action est irréversible. Toutes tes données seront supprimées.",
    delete_confirm_btn: "Confirmer la suppression",

    // Visual tab
    mode_label: "Mode",
    mode_dark: "Sombre",
    mode_light: "Clair",
    accent_label: "Couleur d'accentuation",
    accent_gold: "Or",
    accent_blue: "Bleu",
    accent_purple: "Violet",
    accent_red: "Rouge",
    bg_label: "Fond",
    bg_default: "Défaut",
    bg_minimal: "Minimal",
    bg_animated: "Animé",

    // Upsell
    upsell_anon: [
      "Tu as analysé 20 parties — crée un compte gratuit pour passer à 30.",
      "Retrouve tes derniers pseudos automatiquement avec un compte gratuit.",
      "Sauvegarde tes 10 derniers rapports dans ton historique — compte gratuit.",
    ],
    upsell_free: [
      "Tu analyses 30 parties. Passe Premium pour 50 parties + winrate saison réelle.",
      "Squad Ranking : compare ton score à tes amis — disponible en Premium.",
      "Partage ton rapport avec un lien unique — disponible en Premium.",
    ],
    upsell_score_low: (score) => `${score}/100 — Tu peux faire mieux. Premium analyse 50 parties pour cibler exactement tes lacunes.`,
    upsell_score_mid: (score) => `${score}/100, dans la moyenne. Vois où tu te situes face à tes amis avec le Squad Ranking Premium.`,
    upsell_score_high: (score) => `${score}/100 — beau score ! Partage-le avec un lien et défie tes amis. Disponible en Premium.`,
    upsell_limit_0: "Tu as atteint ta limite quotidienne. Premium = recherches illimitées.",
    upsell_limit_n: (n) => `Plus que ${n} recherche${n > 1 ? "s" : ""} aujourd'hui. Premium = illimité.`,
    // Sans compte, l'étape suivante est l'inscription gratuite, pas l'abonnement.
    upsell_limit_0_anon: "Tu as utilisé tes 3 analyses du jour. Un compte gratuit t'en donne 5 par jour.",
    upsell_limit_n_anon: (n) => `Plus que ${n} analyse${n > 1 ? "s" : ""} aujourd'hui. Un compte gratuit = 5 par jour.`,
    upsell_create_account: "Créer un compte →",
    upsell_go_premium: "Passer Premium →",

    // Toasts
    toast_copied: "Message copié !",
    toast_link_copied: "Lien copié !",
    toast_email_copied: "Email copié !",
    toast_password_changed: "Mot de passe modifié !",
    toast_subscription_cancelled: "Abonnement annulé.",
    toast_account_deleted: "Compte supprimé.",
    toast_challenge: "Ajoute les pseudos de tes amis séparés par des virgules, puis clique Squad Ranking !",
    toast_error_pass: "Erreur lors du déblocage.",
    toast_error_delete: "Erreur lors de la suppression.",
    toast_verified: "Email vérifié ! Tu peux maintenant te connecter.",
    toast_profile_published: "Profil publié dans la communauté !",
    toast_profile_removed: "Profil retiré de la communauté.",
    toast_new_link: "Nouveau lien généré !",

    // Product Hunt
    ph_banner_soon: "On lance sur Product Hunt le 13 à midi — viens nous soutenir",
    ph_banner_live: "On est sur Product Hunt aujourd'hui — un clic pour nous upvoter",

    // Footer
    privacy_policy: "Politique de confidentialité",
    legal_notice: "Mentions légales",
    cgu: "CGU",
    contact: "Contact",

    // DashboardVisual
    readonly_viewing: "Rapport de",
    generate_yours: "Tu penses faire mieux ? →",
    readonly_challenge_sub: (player) => `${player} a été roasté. À ton tour.`,
    accuracy_question: "Cette analyse était-elle précise ?",
    accuracy_yes: "✓ Oui",
    accuracy_no: "✗ Pas vraiment",
    accuracy_thanks: "Merci pour ton retour !",
    accuracy_error: "Ton avis n'a pas pu être envoyé. Réessaie dans un moment.",

    // Carte d'avis (FeedbackToast) — textes longtemps codes en dur, donc jamais
    // traduits : un visiteur anglophone lisait « Tu kiffes l'appli ? ».
    feedback_question: "Ton avis sur Roast My Stats ?",
    feedback_placeholder: "Un commentaire ? (optionnel)",
    feedback_submit: "Envoyer",
    feedback_thanks: "Merci pour ton avis !",
    feedback_close: "Fermer",
    ai_followup_placeholder: "Pose une question au coach...",
    ai_followup_btn: "Demander",
    ai_followup_loading: "En cours...",
    niv: "Niv.",
    trend_up: "↑ En progression",
    trend_down: "↓ En déclin",
    winrate: "Winrate",
    winrate_season: "Winrate saison",
    kda_avg: "KDA moyen",
    kda: "K / D / A",
    damage: "Dégâts",
    kill_participation: "Participation",
    game_sense: "Game Sense",
    games: "Parties",
    badge_locked: "Image de champion incluse dans le Pass 24h",
    radar_title: "Performance Par Champion",
    champ_perf_title: "Détail par champion",
    champ_perf_hint: "Score basé sur KDA · dégâts · victoires",
    champ_perf_game: "partie",
    champ_perf_games: "parties",
    champ_perf_low_tooltip: "Moins de 3 parties — score peu fiable",
    champ_perf_footer: "⚠ = moins de 3 parties analysées, score indicatif uniquement",
    champ_perf_hidden: (n, g) => `+ ${n} champion${n > 1 ? "s" : ""} non affiché${n > 1 ? "s" : ""} · ${g} partie${g > 1 ? "s" : ""} supplémentaire${g > 1 ? "s" : ""}`,
    tips_title: "Conseils pour progresser",
    tips_based_on: (n) => `Basé sur tes ${n} dernières parties`,
    tips_upgrade_50: "~50 avec Premium",
    tips_upgrade_free: "10 avec un compte · ~50 avec Premium",
    tips_show_more: (n) => `▼ Voir ${n} conseil${n > 1 ? "s" : ""} de plus`,
    tips_collapse: "▲ Réduire",
    premium_teaser_title: "Débloque le Pass 24h",
    premium_teaser_sub: "Coach IA · 50 parties · Squad Ranking · Re-roast · Image de champion",
    premium_teaser_btn: "Voir le Pass",
    friends_title: "Classement Amis",
    friends_empty: "Entre plusieurs pseudos séparés par des virgules et clique Squad Ranking pour voir ton classement !",
    history_title: "Historique des Rapports",
    history_progression: (player) => `Progression — ${player}`,
    // n = part estimée de joueurs situés en dessous. Les deux extrêmes ont besoin
    // d'une formulation dédiée : « top 0% » et « meilleur que 0% » ne veulent rien dire.
    score_percentile: (n) =>
      n >= 99
        ? `Dans le top ${(100 - n).toFixed(1).replace(".", ",")} % des joueurs`
        : n < 1
          ? "Meilleur que moins de 1 % des joueurs"
          : `Meilleur que ${Math.round(n)} % des joueurs`,
    score_percentile_est: "estimation d'après ton rang",
    score_percentile_unranked: "estimation — profil non classé",
    axes_title: "Profil de jeu",
    axis_combat: "Combat",
    axis_macro: "Macro",
    axis_survival: "Survie",
    axis_impact: "Impact",
    axes_legend: "50 = la moyenne de ton poste",
    role_TOP: "Toplane", role_JUNGLE: "Jungle", role_MIDDLE: "Midlane",
    role_BOTTOM: "ADC", role_UTILITY: "Support",
    history_avg: (n) => `Moy. ${n}/100`,
    periode_semaine: "Semaine",
    periode_mois: "Mois",
    periode_annee: "Année",
    periode_tout: "Tout",
    periode_vide: "Pas assez de rapports sur cette période.",
    agregat_jour: (n) => `${n} rapports — moyenne par jour`,
    agregat_semaine: (n) => `${n} rapports — moyenne par semaine`,
    agregat_mois: (n) => `${n} rapports — moyenne par mois`,
    agregat_brut: (n) => `${n} rapports`,
    chart_tooltip_agregat: (n) => n > 1 ? ` — moyenne de ${n} rapports` : "",
    history_empty: "Aucun rapport enregistré pour l'instant.",
    history_premium_locked: "Crée un compte gratuit pour garder ton historique",
    history_go_premium: "Créer un compte",
    history_show_more: (n) => `Voir ${n} de plus ▼`,
    history_show_less: "Voir moins ▲",
    generate_own: "Tente de battre ce score",
    new_report_btn: "Nouveau rapport",
    challenge_btn: "Défie tes amis !",
    share_btn: "Partager Mon Rapport",
    community_title: "Communauté",
    community_sub: "Profils publiés par les membres",
    community_publish: "Publier mon profil",
    community_unpublish: "Retirer mon profil",
    community_premium_locked: "Crée un compte gratuit pour voir la communauté",
    community_empty: "Aucun membre n'a encore publié son profil.",
    leaderboard_global: "Classement Global",
    leaderboard_best_score: "Meilleur score par joueur",
    leaderboard_global_empty: "Aucun joueur classé pour l'instant. Génère des rapports pour apparaître ici !",
    chart_tooltip_score: (v) => ` ${v}/100`,
    chart_tooltip_avg: (v) => ` Moy. ${v}/100`,

    // LoginModal
    lm_title: "Roast My Stats",
    lm_verify_title: "Vérifie ton adresse email",
    lm_verify_pre: "Un lien de confirmation a été envoyé à",
    lm_resend: "Renvoyer l'email",
    lm_resend_error: "Impossible de renvoyer l'email.",
    lm_tab_login: "Connexion",
    lm_tab_register: "Inscription",
    lm_signup_premium_pitch: "Ton premier Pass 24h offert à la création de compte",
    lm_step1_welcome: "Bienvenue !",
    lm_firstname_placeholder: "Ton prénom",
    lm_birthdate_sub: "Date de naissance — tu dois avoir 15 ans minimum (RGPD).",
    lm_continue: "Continuer →",
    lm_back: "← Retour",
    lm_step2_title: (name) => `Crée ton compte, ${name} !`,
    lm_email_placeholder: "Email",
    lm_password_placeholder: "Mot de passe",
    lm_confirm_placeholder: "Confirmer le mot de passe",
    lm_step3_title: "Dernière étape !",
    lm_accept_privacy: "J'accepte la",
    lm_privacy_link: "politique de confidentialité",
    lm_read_first: "— lis d'abord",
    lm_accept_cgu: "J'accepte les",
    lm_cgu_link: "conditions générales d'utilisation",
    lm_create_account: "Créer mon compte",
    lm_forgot_title: "Lien de réinitialisation",
    lm_forgot_sub: "Si cet email existe, tu recevras un lien de réinitialisation valable 1h.",
    lm_resend_link: (n) => n > 0 ? `Renvoyer le lien (${n}s)` : "Renvoyer le lien",
    lm_forgot_input: "Entre ton email et on t'envoie un lien de réinitialisation.",
    lm_send_link: "Envoyer le lien",
    lm_return: "Retour",
    lm_connect: "Se connecter",
    lm_forgot_password: "Mot de passe oublié ?",
    lm_error_email: "Entre ton email.",
    lm_error_fields: "Remplis tous les champs.",
    lm_error_legal: "Tu dois accepter les deux documents pour continuer.",
    lm_error_firstname: "Entre ton prénom.",
    lm_error_birthdate: "Entre ta date de naissance.",
    lm_error_age: "Tu dois avoir au moins 15 ans pour créer un compte. Si tu as moins de 15 ans, demande à un parent de s'inscrire à ta place.",
    lm_error_email_taken: "Un compte existe déjà avec cette adresse email.",

    // Footer legal
    privacy_modal_title: "Politique de Confidentialité",
    cgu_modal_title: "Conditions Générales d'Utilisation",
    contact_modal_title: "Contact",
    contact_modal_sub: "Pour toute question, envoie-nous un email :",
    contact_subject_placeholder: "Sujet (optionnel)",
    contact_message_placeholder: "Ton message...",
    contact_send: "Envoyer",
    contact_sending: "Envoi...",
    contact_sent_title: "Message envoyé !",
    contact_sent_sub: "On te répond dès que possible.",
    contact_error: "Erreur lors de l'envoi, réessaie.",
    legal_back: "← Retour à l'inscription",
    legal_date: (date) => `Dernière mise à jour : ${date}`,
  },

  en: {
    // Hero
    brand_sub: "Your stats have things to say about you. Not always flattering.",
    seo_intro: "Roast My Stats is a LoL stats analyzer: enter your summoner name, get a score out of 100, a badge based on your main champion, and actionable tips to climb. Our skill analysis covers winrate, champion performance, season progression and more — all regions supported.",
    total_reports: (n) => `${n.toLocaleString("en-US")} players roasted`,
    see_leaderboard: "View leaderboard",
    see_offers: "See the offers",
    go_premium: "Unlock the 24h Pass — €1.99",
    pass_badge: (h) => `Pass — ${h}h`,
    logout: (name) => `${name}  ·  Log out`,
    lang_toggle: "FR",

    // Search
    search_placeholder: "Summoner name (or multiple separated by commas)",
    btn_report: "Player report",
    btn_squad: "Squad ranking",
    btn_demo: "Demo",
    btn_demo_squad: "Squad demo",

    // Searches remaining
    limit_reached: "Daily limit reached",
    searches_remaining: (n) => `${n} search${n > 1 ? "es" : ""} remaining today`,

    // Loading
    loading_premium: "Deep analysis of 50 games...",
    loading_free: "Analyzing 30 games...",
    loading_anon: "Analyzing 20 games — create an account for more accuracy",
    loading_demo: "Generating demo...",
    loading_squad: "Generating squad demo...",

    // Errors
    error_not_found: "Player not found. Check the summoner name (format: Name#TAG) and region.",
    error_try_demo: "See an example →",
    error_squad_premium: "Squad Ranking is a Premium feature.",
    error_squad: "Error generating squad.",
    error_demo: "Error generating demo.",
    error_demo_squad: "Error generating squad demo.",
    go_premium_btn: "Go Premium →",

    // Leaderboard page
    leaderboard_page_title: "Global Leaderboard",
    leaderboard_best: "Best score per player",
    leaderboard_updated: "Updated with every report",
    leaderboard_empty: "No players ranked yet.",
    leaderboard_analyze: "Analyze my profile",
    back: "← Back",

    // Leaderboard submit
    lb_submit_label: "Add a summoner to the public leaderboard:",
    lb_submit_placeholder: "Summoner#TAG",
    lb_submit_btn: "Join",
    lb_submit_done: "✓ Added",

    // Squad
    squad_title: "Squad Ranking",
    new_report: "← New report",

    cancel: "Cancel",

    // Pricing
    choose_offer: "Choose a plan",
    choose_offer_sub: "Compare plans and find the one that suits you",
    plan_no_account: "No account",
    plan_free: "Free account",
    plan_premium: "Premium",
    plan_free_price: "Free",
    plan_free_account_price: "€0",
    plan_premium_price: "€1.99 / 24h",
    quota_anon: "3 reports / day",
    quota_free: "5 reports / day",
    quota_premium: "Unlimited reports",
    feature_history: "Report history",
    feature_suggestions: "Search suggestions",
    feature_share: "Share report",
    feature_themes: "Visual themes",
    feature_squad: "Squad Ranking",
    feature_community: "Community profile",
    feature_ai_coach: "Personalized AI coach",
    feature_referrals_none: "Referral link",
    feature_referrals_link: "Referral link to share",
    create_account: "Create account",
    go_premium_cta: "Go Premium",
    active_badge: "Active",

    // Waitlist
    going_premium: "The 24h Pass is coming 🚀",
    pass_body_anon: "Payment isn't open yet: we're measuring interest before wiring up the till. Leave your e-mail — we'll give you a full 24h Pass the day it opens. And to thank you for showing up early, your Premium is unlocked right now, for 24h.",
    pass_body_user: "Payment isn't open yet: we're measuring interest before wiring up the till. The day it opens, your first 24h Pass is on us. And to thank you for showing up early, your Premium is unlocked right now, for 24h.",
    pass_cta_anon: "Unlock my 24h of Premium",
    email_placeholder: "your@email.com",
    pass_cta_user: "Enjoy the free Premium",
    pass_success_title: "Unlocked 🎉",
    pass_success_body: "Your 24h of Premium is live. Go get roasted properly.",
    pass_success_mail: "We just sent you an e-mail to pick a password and keep your account.",
    pass_already_title: "You're already Premium",
    pass_already_body: "Your Premium access is already active — no pass needed right now.",
    pass_existing_account: "An account already exists with this address. Log in, then click again to unlock your 24h.",
    pass_error: "Can't unlock the pass right now. Try again in a moment.",
    close: "Close",

    // Share
    share_title: "Share My Report",
    feature_roast_levels: "Roast intensity + re-roast",
    prog_title: (jours) => `Your progress over ${jours} days`,
    prog_score: "Score",
    prog_deaths: "Deaths per game",
    prog_kda: "KDA",
    prog_winrate: "Winrate",
    trophies_title: "Trophies",
    trophies_new: (noms) => `New trophy unlocked: ${noms}`,
    roast_gentil: "Gentle",
    roast_piquant: "Spicy",
    roast_sans_pitie: "No mercy",
    roast_again: "Re-roast",
    roast_loading: "Cooking...",
    roast_error: "The roast didn't come out, try again.",
    share_message_label: "Ready to paste:",
    share_message: (score, badge, url) => `Just analyzed my LoL stats — ${score}/100, "${badge}"\nBet you can't do better:\n${url}`,
    discord_message: (player, score, badge, url) => `**Roast My Stats** — ${player}\nScore: **${score}/100** · *${badge}*\n${url}`,
    copy_message: "Copy message",
    link_only: "Link only:",
    copy: "Copy",
    discord_copied: "Discord message copied — paste it in your server!",

    // Reset password
    new_password_title: "New password",
    pw_new_label: "New password",
    pw_confirm_label: "Confirm password",
    pw_reset_btn: "Reset password",
    pw_updated_title: "Password updated!",
    pw_updated_sub: "You can now log in.",
    login_btn: "Log in",

    // Settings
    settings_title: "Settings",
    tab_account: "Account",
    tab_password: "Password",
    tab_premium: "Subscription",
    tab_visual: "Visual",

    // Premium tab
    pass_ongoing: (h) => `24h Pass active — ${h}h remaining`,
    upgrade_premium: "Unlock the 24h Pass — €1.99",
    referral_title: "Your referral link",
    referral_sub: "Your friends get their first 24h Pass free when they sign up, just like you did.",
    referral_gift_banner: "A free 24h Pass is waiting for you — sign up now!",
    regenerate: "Regenerate",
    link_copied: "Link copied!",
    new_link_generated: "New link generated!",
    cancel_subscription: "Cancel subscription",
    cancel_sub_confirm_msg: "Are you sure? You will lose Premium access immediately.",
    cancel_sub_confirm_btn: "Yes, cancel subscription",

    // Password tab
    pw_current: "Current password",
    pw_new_placeholder: "New password",
    pw_confirm_placeholder: "Confirm new password",
    change_password: "Change password",
    criteria_8chars: "At least 8 characters",
    criteria_uppercase: "One uppercase letter",
    criteria_number: "One number",
    criteria_special: "One special character",

    // Account tab
    label_name: "Name",
    label_email: "Email",
    label_subscription: "Subscription",
    label_language: "Language",
    sub_premium: "Premium",
    sub_free: "Free",
    delete_account: "Delete my account",
    delete_confirm_msg: "This action is irreversible. All your data will be deleted.",
    delete_confirm_btn: "Confirm deletion",

    // Visual tab
    mode_label: "Mode",
    mode_dark: "Dark",
    mode_light: "Light",
    accent_label: "Accent color",
    accent_gold: "Gold",
    accent_blue: "Blue",
    accent_purple: "Purple",
    accent_red: "Red",
    bg_label: "Background",
    bg_default: "Default",
    bg_minimal: "Minimal",
    bg_animated: "Animated",

    // Upsell
    upsell_anon: [
      "You've analyzed 20 games — create a free account to unlock 30.",
      "Automatically retrieve your recent summoner names with a free account.",
      "Save your last 10 reports in your history — free account.",
    ],
    upsell_free: [
      "You analyze 30 games. Go Premium for 50 games + real season winrate.",
      "Squad Ranking: compare your score with friends — Premium only.",
      "Share your report with a unique link — Premium only.",
    ],
    upsell_score_low: (score) => `${score}/100 — room to improve. Premium analyzes 50 games to pinpoint exactly where.`,
    upsell_score_mid: (score) => `${score}/100, around average. See how you stack up against friends with Premium Squad Ranking.`,
    upsell_score_high: (score) => `${score}/100 — nice score! Share it with a link and challenge your friends. Premium only.`,
    upsell_limit_0: "You've reached your daily limit. Premium = unlimited searches.",
    upsell_limit_n: (n) => `${n} search${n > 1 ? "es" : ""} remaining today. Premium = unlimited.`,
    upsell_limit_0_anon: "You've used your 3 analyses for today. A free account gives you 5 a day.",
    upsell_limit_n_anon: (n) => `${n} analys${n > 1 ? "es" : "is"} left today. A free account = 5 a day.`,
    upsell_create_account: "Create account →",
    upsell_go_premium: "Go Premium →",

    // Toasts
    toast_copied: "Message copied!",
    toast_link_copied: "Link copied!",
    toast_email_copied: "Email copied!",
    toast_password_changed: "Password updated!",
    toast_subscription_cancelled: "Subscription cancelled.",
    toast_account_deleted: "Account deleted.",
    toast_challenge: "Add your friends' summoner names separated by commas, then click Squad Ranking!",
    toast_error_pass: "Error unlocking the pass.",
    toast_error_delete: "Error deleting account.",
    toast_verified: "Email verified! You can now log in.",
    toast_profile_published: "Profile published in the community!",
    toast_profile_removed: "Profile removed from community.",
    toast_new_link: "New link generated!",

    // Product Hunt
    ph_banner_soon: "We launch on Product Hunt Sept 13 at noon CEST — come support us",
    ph_banner_live: "We're live on Product Hunt today — one click to upvote us",

    // Footer
    privacy_policy: "Privacy Policy",
    legal_notice: "Legal notice",
    cgu: "Terms of Service",
    contact: "Contact",

    // DashboardVisual
    readonly_viewing: "Report of",
    generate_yours: "Think you can do better? →",
    readonly_challenge_sub: (player) => `${player} got roasted. Your turn.`,
    accuracy_question: "Was this analysis accurate?",
    accuracy_yes: "✓ Yes",
    accuracy_no: "✗ Not really",
    ai_followup_placeholder: "Ask the coach a question...",
    ai_followup_btn: "Ask",
    ai_followup_loading: "Loading...",
    accuracy_thanks: "Thanks for your feedback!",
    accuracy_error: "Your feedback could not be sent. Try again in a moment.",

    feedback_question: "How do you like Roast My Stats?",
    feedback_placeholder: "Any comment? (optional)",
    feedback_submit: "Send",
    feedback_thanks: "Thanks for your feedback!",
    feedback_close: "Close",
    niv: "Lv.",
    trend_up: "↑ Improving",
    trend_down: "↓ Declining",
    winrate: "Winrate",
    winrate_season: "Season winrate",
    kda_avg: "Avg KDA",
    kda: "K / D / A",
    damage: "Damage",
    kill_participation: "Kill participation",
    game_sense: "Game Sense",
    games: "Games",
    badge_locked: "Champion image included in the 24h Pass",
    radar_title: "Performance Per Champion",
    champ_perf_title: "Champion breakdown",
    champ_perf_hint: "Score based on KDA · damage · wins",
    champ_perf_game: "game",
    champ_perf_games: "games",
    champ_perf_low_tooltip: "Less than 3 games — unreliable score",
    champ_perf_footer: "⚠ = fewer than 3 games analyzed, indicative score only",
    champ_perf_hidden: (n, g) => `+ ${n} more champion${n > 1 ? "s" : ""} · ${g} additional game${g > 1 ? "s" : ""} not shown`,
    tips_title: "Tips to improve",
    tips_based_on: (n) => `Based on your last ${n} games`,
    tips_upgrade_50: "~50 with Premium",
    tips_upgrade_free: "10 with an account · ~50 with Premium",
    tips_show_more: (n) => `▼ Show ${n} more tip${n > 1 ? "s" : ""}`,
    tips_collapse: "▲ Collapse",
    premium_teaser_title: "Unlock the 24h Pass",
    premium_teaser_sub: "AI Coach · 50 games · Squad Ranking · Re-roast · Champion image",
    premium_teaser_btn: "View the Pass",
    friends_title: "Squad Ranking",
    friends_empty: "Enter multiple summoner names separated by commas and click Squad Ranking to see your ranking!",
    history_title: "Report History",
    history_progression: (player) => `Progression — ${player}`,
    score_percentile: (n) =>
      n >= 99
        ? `In the top ${(100 - n).toFixed(1)}% of players`
        : n < 1
          ? "Better than less than 1% of players"
          : `Better than ${Math.round(n)}% of players`,
    score_percentile_est: "estimated from your rank",
    score_percentile_unranked: "estimate — unranked profile",
    axes_title: "Play profile",
    axis_combat: "Combat",
    axis_macro: "Macro",
    axis_survival: "Survival",
    axis_impact: "Impact",
    axes_legend: "50 = the average for your role",
    role_TOP: "Top", role_JUNGLE: "Jungle", role_MIDDLE: "Mid",
    role_BOTTOM: "ADC", role_UTILITY: "Support",
    history_avg: (n) => `Avg. ${n}/100`,
    periode_semaine: "Week",
    periode_mois: "Month",
    periode_annee: "Year",
    periode_tout: "All",
    periode_vide: "Not enough reports in this period.",
    agregat_jour: (n) => `${n} reports — daily average`,
    agregat_semaine: (n) => `${n} reports — weekly average`,
    agregat_mois: (n) => `${n} reports — monthly average`,
    agregat_brut: (n) => `${n} reports`,
    chart_tooltip_agregat: (n) => n > 1 ? ` — average of ${n} reports` : "",
    history_empty: "No reports saved yet.",
    history_premium_locked: "Create a free account to keep your history",
    history_go_premium: "Create account",
    history_show_more: (n) => `Show ${n} more ▼`,
    history_show_less: "Show less ▲",
    generate_own: "Try to beat this score",
    new_report_btn: "New report",
    challenge_btn: "Challenge your friends!",
    share_btn: "Share My Report",
    community_title: "Community",
    community_sub: "Profiles published by members",
    community_publish: "Publish my profile",
    community_unpublish: "Remove my profile",
    community_premium_locked: "Create a free account to see the community",
    community_empty: "No member has published their profile yet.",
    leaderboard_global: "Global Leaderboard",
    leaderboard_best_score: "Best score per player",
    leaderboard_global_empty: "No players ranked yet. Generate reports to appear here!",
    chart_tooltip_score: (v) => ` ${v}/100`,
    chart_tooltip_avg: (v) => ` Avg. ${v}/100`,

    // LoginModal
    lm_title: "Roast My Stats",
    lm_verify_title: "Check your email",
    lm_verify_pre: "A confirmation link has been sent to",
    lm_resend: "Resend email",
    lm_resend_error: "Unable to resend email.",
    lm_tab_login: "Log in",
    lm_tab_register: "Sign up",
    lm_signup_premium_pitch: "Your first 24h Pass free when you create an account",
    lm_step1_welcome: "Welcome!",
    lm_firstname_placeholder: "Your first name",
    lm_birthdate_sub: "Date of birth — you must be at least 15 years old (GDPR).",
    lm_continue: "Continue →",
    lm_back: "← Back",
    lm_step2_title: (name) => `Create your account, ${name}!`,
    lm_email_placeholder: "Email",
    lm_password_placeholder: "Password",
    lm_confirm_placeholder: "Confirm password",
    lm_step3_title: "Last step!",
    lm_accept_privacy: "I accept the",
    lm_privacy_link: "privacy policy",
    lm_read_first: "— read it first",
    lm_accept_cgu: "I accept the",
    lm_cgu_link: "terms of service",
    lm_create_account: "Create account",
    lm_forgot_title: "Reset link",
    lm_forgot_sub: "If this email exists, you'll receive a reset link valid for 1 hour.",
    lm_resend_link: (n) => n > 0 ? `Resend link (${n}s)` : "Resend link",
    lm_forgot_input: "Enter your email and we'll send you a reset link.",
    lm_send_link: "Send link",
    lm_return: "Back",
    lm_connect: "Log in",
    lm_forgot_password: "Forgot password?",
    lm_error_email: "Enter your email.",
    lm_error_fields: "Fill in all fields.",
    lm_error_legal: "You must accept both documents to continue.",
    lm_error_firstname: "Enter your first name.",
    lm_error_birthdate: "Enter your date of birth.",
    lm_error_age: "You must be at least 15 years old to create an account. If you're under 15, ask a parent to sign up on your behalf.",
    lm_error_email_taken: "An account already exists with this email address.",

    // Footer legal
    privacy_modal_title: "Privacy Policy",
    cgu_modal_title: "Terms of Service",
    contact_modal_title: "Contact",
    contact_modal_sub: "For any questions, send us an email:",
    contact_subject_placeholder: "Subject (optional)",
    contact_message_placeholder: "Your message...",
    contact_send: "Send",
    contact_sending: "Sending...",
    contact_sent_title: "Message sent!",
    contact_sent_sub: "We'll get back to you as soon as possible.",
    contact_error: "Error sending message, please try again.",
    legal_back: "← Back to sign up",
    legal_date: (date) => `Last updated: ${date}`,
  },
};

export default T;
